import React from 'react';
import { Slider, Stack, Text } from '@fluentui/react';
import { ConfigCheckbox } from './ConfigCheckbox';
import { AdminContext } from 'Store/Admin';
import { numericalSpacingStackTokens } from '../SettingsStyles';
import sampleImg from '../../../assets/img/shippingContainers.png';
import { ImageUrlType } from '../../shared/content/jsonContentTypes/ImageUrlType';

interface ContentPreviewsProps {
  displayName: string;
}

export const ContentPreviews: React.FunctionComponent<ContentPreviewsProps> = props => {
  const { state, dispatch } = React.useContext(AdminContext);

  const handleSliderChange = (type: string, newValue?: number) => {
    if (newValue !== undefined) {
      dispatch({
        // TODO: make all actions enums so we can pass them around
        // https://microsoft.visualstudio.com/Xbox/_workitems/edit/35699367/?workitem=36892140
        // @ts-ignore
        type: type,
        // @ts-ignore
        payload: newValue
      });
      dispatch({
        type: 'IS_UPDATED',
        payload: true
      });
    }
  };

  const imageUxPreferences = state.queueDataState?.uxPreferences.subjectImage;
  return (
    <Stack>
      <Text as={'h2'} variant={'xLarge'} style={{ height: 24 }} className={'my-2'}>
        {'Protect moderator wellness'}
      </Text>
      <Text variant={'mediumPlus'} style={{ width: 504 }}>
        {'Blur, desaturate, and/or flip content thumbnails to reduce impact of viewing harmful content'}
      </Text>
      <Text variant={'mediumPlus'} style={{ marginTop: 32 }}>
        {`Select the default thumbnail styles for ${props.displayName} queue cases:`}
      </Text>
      <Stack
        horizontal
        tokens={numericalSpacingStackTokens}
        className={'mt-3'}
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Stack>
          <ConfigCheckbox
            className="mt-0"
            tooltip={''}
            id="isDefaultBlur"
            label={'Blur'}
            value={!!imageUxPreferences?.isDefaultBlur}
          />
          {!!imageUxPreferences?.isDefaultBlur && (
            <Stack.Item style={{ minWidth: 300 }}>
              <Slider
                aria-label="Blur strength"
                min={5}
                max={100}
                value={imageUxPreferences.blurStrengthPixels}
                onChange={(newValue: number) =>
                  handleSliderChange('UPDATE_UXPREFERENCES_BLUR_STRENGTH_PIXELS', newValue)
                }
              />
            </Stack.Item>
          )}
          <ConfigCheckbox
            className=""
            tooltip={''}
            id="isDefaultGrayscale"
            label={'Desaturate'}
            value={!!imageUxPreferences?.isDefaultGrayscale}
          />
          {!!imageUxPreferences?.isDefaultGrayscale && (
            <Stack.Item style={{ minWidth: 300 }}>
              <Slider
                aria-label="Grayscale percent"
                min={5}
                max={100}
                value={imageUxPreferences.grayScalePercent}
                onChange={(newValue: number) => handleSliderChange('UPDATE_UXPREFERENCES_GRAYSCALE_PERCENT', newValue)}
              />
            </Stack.Item>
          )}
          <ConfigCheckbox
            className=""
            tooltip={''}
            id="isDefaultFlipped"
            label={'Flip'}
            value={!!imageUxPreferences?.isDefaultFlipped}
          />
          <ConfigCheckbox
            className=""
            tooltip={''}
            id="isTextBlurred"
            label={'Blur Text'}
            value={!!imageUxPreferences?.isTextBlurred}
          />
        </Stack>
        <Stack style={{ marginTop: 5 }}>
          <ImageUrlType
            subjectImagePreferences={state.queueDataState?.uxPreferences.subjectImage}
            value={sampleImg}
            caption={''}
            isGridView={false}
            uxPreferences={state.queueDataState?.uxPreferences}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
